import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Button from 'flarum/common/components/Button';
import GiveMeritModal from './components/GiveMeritModal';

export function addMeritButtons() {
    extend(CommentPost.prototype, 'actionItems', function (items) {
        const post = this.attrs.post;
        if (!post || post.isHidden()) return;

        const meritReceived = post.attribute('meritReceived') || 0;
        const smeritReceived = post.attribute('smeritReceived') || 0;
        const hasGivenMerit = post.attribute('hasGivenMerit');
        const hasGivenSmerit = post.attribute('hasGivenSmerit');
        const canGiveMerit = post.attribute('canGiveMerit');
        const canGiveSmerit = post.attribute('canGiveSmerit');

        // Merit count display
        if (meritReceived > 0 || smeritReceived > 0) {
            items.add('merit-counts', (
                <span className="Post-merit-counts">
                    {meritReceived > 0 && <span className="merit-count"><i className="fas fa-award" /> {meritReceived} Merit</span>}
                    {smeritReceived > 0 && <span className="smerit-count"><i className="fas fa-medal" /> {smeritReceived} sMerit</span>}
                </span>
            ), 5);
        }

        // Give Merit button
        if (app.session.user) {
            if (canGiveMerit && !hasGivenMerit) {
                items.add('give-merit', (
                    <Button
                        className="Button Button--link Button--merit"
                        onclick={() => app.modal.show(GiveMeritModal, { post, type: 'merit' })}
                        icon="fas fa-award"
                    >
                        {app.translator.trans('predictiontalk-merit-system.forum.merit.give_button')}
                    </Button>
                ), 4);
            } else if (hasGivenMerit) {
                items.add('give-merit', (
                    <Button className="Button Button--link Button--merit active" disabled={true} icon="fas fa-award">
                        {app.translator.trans('predictiontalk-merit-system.forum.merit.give_button')}
                    </Button>
                ), 4);
            }

            // Give sMerit button
            if (canGiveSmerit && !hasGivenSmerit) {
                items.add('give-smerit', (
                    <Button
                        className="Button Button--link Button--smerit"
                        onclick={() => app.modal.show(GiveMeritModal, { post, type: 'smerit' })}
                        icon="fas fa-medal"
                    >
                        {app.translator.trans('predictiontalk-merit-system.forum.merit.give_smerit_button')}
                    </Button>
                ), 3);
            } else if (hasGivenSmerit) {
                items.add('give-smerit', (
                    <Button className="Button Button--link Button--smerit active" disabled={true} icon="fas fa-medal">
                        {app.translator.trans('predictiontalk-merit-system.forum.merit.give_smerit_button')}
                    </Button>
                ), 3);
            }
        }
    });
}
